import { Tracing } from 'trace_events';
import BaseServiceApi from './baseapi';

export interface UserType {
  email: string | null;
  id: number;
  isInstitutionUser: boolean;
  mobileNumber: string;
}

export interface UserContactInfoType {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  saveFlag: boolean;
  emailVerifyEd:boolean;
}

export function getUserInfo() {
  return BaseServiceApi.get<UserType>('/api/ch/se/if', {});
}

export function getUserContactInfo() {
  return BaseServiceApi.get<{ data: UserContactInfoType }>('/api/v2/ch/pc/uc', {});
}

export function reviseUserContactInfo(data: UserContactInfoType) {
  return BaseServiceApi.post('/api/v2/ch/pc/puc', { ...data });
}

export function getUserLanguage() {
  return BaseServiceApi.get<{ data: any[] }>('/api/ch/us/d', { names: 'LANGUAGE' });
}

export function setUserLanguage(lang: string) {
  const valueStr = { code: lang };
  const value = JSON.stringify(valueStr);
  return BaseServiceApi.post('/api/ch/us/d', { names: 'LANGUAGE', value });
}

export function verifiedEmail() {
  return BaseServiceApi.get('/api/v2/ch/pc/uc/se',{});
}
